/**
 * ProposalService.js
 * Handles logic for "Wisdom of Stars" (User Proposals)
 */
import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";
import { app } from "../firebase-config.js";

const db = getFirestore(app);

export const ProposalService = {
    /**
     * Submit a new proposal
     * @param {Object} data - { title, content, version }
     * @returns {Promise<string>} - Doc ID
     */
    async submitProposal({ title, content, version }) {
        if (!window.user) throw new Error("로그인이 필요합니다.");

        // Validation
        if (!title || title.trim().length === 0) throw new Error("제목을 입력해주세요.");
        if (!content || content.trim().length === 0) throw new Error("내용을 입력해주세요.");

        try {
            const docRef = await addDoc(collection(db, "proposals"), {
                userId: window.user.uid,
                userEmail: window.user.email,
                userName: window.user.displayName || 'Anonymous',
                title: title.trim(),
                content: content.trim(),
                status: 'pending', // pending, approved, rejected, implemented
                version: version || 'unknown',
                createdAt: serverTimestamp(),
                updatedAt: serverTimestamp()
            });

            await import("./notification-trigger.service.js").then(({ NotificationTriggerService }) => {
                NotificationTriggerService.notifyReceipt(window.user.uid, '제안');
            });

            return docRef.id;
        } catch (error) {
            console.error("Proposal Submission Error:", error);
            throw error;
        }
    }
};
